function iconProps(className) {
  return {
    className,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.75",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "aria-hidden": true,
  };
}

export function IconPin({ className = "hero-icon" }) {
  return (
    <svg {...iconProps(className)}>
      <path d="M12 21s7-4.6 7-11a7 7 0 1 0-14 0c0 6.4 7 11 7 11z" />
      <circle cx="12" cy="10" r="2.5" />
    </svg>
  );
}

export function IconClock({ className = "hero-icon" }) {
  return (
    <svg {...iconProps(className)}>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 7v5l3 2" />
    </svg>
  );
}

export function IconCoffee({ className = "hero-icon" }) {
  return (
    <svg {...iconProps(className)}>
      <path d="M8 9h8v5a3 3 0 0 1-3 3h-2a3 3 0 0 1-3-3V9z" />
      <path d="M16 10.5h1.25a2.25 2.25 0 0 1 0 4.5H16" />
      <path d="M9 20h6" />
      <path d="M10 6.2c.35-.55.35-1.1 0-1.65" />
      <path d="M12 6.5c.35-.55.35-1.1 0-1.65" />
      <path d="M14 6.2c.35-.55.35-1.1 0-1.65" />
    </svg>
  );
}

export function IconBrunch({ className = "hero-icon" }) {
  return (
    <svg {...iconProps(className)}>
      <path d="M6.5 3v5" />
      <path d="M9 3v5" />
      <path d="M11.5 3v5" />
      <path d="M6.5 8h5" />
      <path d="M9 8v13" />
      <path d="M15.5 21V3" />
      <path d="M15.5 3c2.1 0.9 3.2 2.4 3.2 5v2" />
    </svg>
  );
}

export function IconHeart({ className = "hero-icon" }) {
  return (
    <svg {...iconProps(className)}>
      <path d="M12 20s-7-4.4-9.2-8.8C1.2 7.8 3.4 5 6.4 5c1.8 0 3.4.9 4.3 2.2C11.6 5.9 13.2 5 15 5c3 0 5.2 2.8 3.6 6.2C19 15.6 12 20 12 20z" />
    </svg>
  );
}

export const heroFeatureIcons = [IconCoffee, IconBrunch, IconHeart];
